let _orgId = null;

export const getOrgId   = () => _orgId;
export const setOrgId   = (id) => { _orgId = id; };
export const clearOrgId = () => { _orgId = null; };
